<template>
	<div class="npa_violations">
		<button @click='toggleModal' class="dropdown-toggle" :disabled='disabled'>
			<span class="caret"></span>
		</button>

		<modal v-model="display_npa_modal" :backdrop='false' width="85%">
			<div slot="modal-header" class="modal-header">
				<h4 class="modal-title">
					<b>Акт {{ act_num }}</b>
				</h4>
			</div>

			<table class='npa-violation-table'>
				<thead>
					<th></th>
					<th>НПА</th>
					<th>Нарушение</th>
				</thead>
				<tbody>
					<tr v-for='i in items' :key='i.id'>
						<td class='npa-violation-td-checkbox'><checkbox type='info' class='npa-violation-checkbox' v-model='i.checked' @input='check(i.id, i.name, i.checked)'></checkbox></td>
						<td>{{i.name}}</td>
						<td>{{i.violation}}</td>
					</tr>
				</tbody>
			</table>

			<div slot="modal-footer" class="modal-footer">
				<button @click='display_npa_modal = false' class="btn btn-default small-button">Закрыть</button>
			</div>
		</modal>
	</div>
	<!-- 
	<dropdown class='npa-violation-dropdown-group form-control' v-model='val' @input='open' :disabled='disabled' :text='names'>
		<li>
			<checkbox type='info' v-model='sel'>Выбрать всё</checkbox>
		</li>
		 <li role="separator" class="divider"></li>
		 <table class='npa-violation-table'>
		 	<thead>
		 		<th></th>
		 		<th>НПА</th>
		 		<th>Нарушение</th>
		 	</thead>
		 	<tbody>
		 		<tr v-for='i in items' :key='i.id'>
		 			<td class='npa-violation-td-checkbox'><checkbox type='info' class='npa-violation-checkbox' v-model='i.checked' @input='check(i.id, i.name, i.checked)'></checkbox></td>
		 			<td>{{i.name}}</td>
		 			<td>{{i.violation}}</td>
		 		</tr>
		 	</tbody>
		 </table>
	</dropdown> -->
</template>

<script>
	import { dropdown, checkbox, modal } from 'vue-strap'
	import { EventBus } from '../../../lib/EventBus'
	import {DB} from './../../../constants'

	const NPA_VIOLATION = 'get_npa_violation.php'
	//const WARRANT_INFO = 'get_warrant_info.php'

	export default {
		name: 'npaViolation',
		data () {
			return {
				display_npa_modal: false,
				items: [],
				names: '',
				names_obj: {},
				val: false,
				sel: false,
			}
		},
		props: {
			disabled: false,
			npa: {},
			act_num: null
		},
		components: {
			dropdown,
			checkbox,
			modal
		},
		watch: {
			sel (e) {
				this.items.map(t => {
					t.checked = e
				})
			},
		},
		methods: {
			toggleModal () {
				this.display_npa_modal = !this.display_npa_modal

				if (this.display_npa_modal && this.npa) {
					for (let i = 0; i < this.npa.length; i++) {
						for (let j = 0; j < this.items.length; j++) {
							if (this.npa[i] == this.items[j].id) {
								//console.warn(this.items[j])
								this.items[j].checked = true
							}
						}
					}
				}
			},
			check(id,name,value) {
				if (value)
					this.names_obj[id] = name
				else
					this.names_obj[id] = null

				let text = ''
				let ids = []
				for (let key in this.names_obj) {
					if (typeof this.names_obj[key] != 'undefined' && this.names_obj[key] != null) {
						text += this.names_obj[key] + ', '
						ids.push(key)
					}
				}

				text = text.slice(0, -2)

				if (text.length > 105)
					this.names = text.slice(0,105) + '...'
				else
					this.names = text

				//console.warn(ids)
				this.$emit('change', ids)
			},
			open (show) {
				//console.warn(this.npa)
				if (show && this.npa) {
					/*let _ids = ''
					for (let i = 0; i < this.npa.length; i++) {
						_ids += this.npa[i]
					}

					_ids = _ids.slice(1,-1).split(',')*/
					//console.warn(this.npa)
					for (let i = 0; i < this.npa.length; i++) {
						for (let j = 0; j < this.items.length; j++) {
							if (this.npa[i] == this.items[j].id) {
								//console.warn(this.items[j])
								this.items[j].checked = true
							}
						}
					}
				}
				
			},
			fill (ids) {
				fetch(DB + NPA_VIOLATION)
				.then(res => res.json())
				.then(res => {
					if (res) {
						let arr = res.map(r => {
							return {
								id: r.id,
								name: r.name,
								violation: r.violation,
								checked: false
							}
						})

						//console.warn(ids)
						if (typeof ids != 'undefined') {
							let text = ''
							for (let i = 0; i < ids.length; i++) {
								for (let j = 0; j < arr.length; j++){
									if (ids[i] == arr[j].id) {
										text += arr[j].name + ', '
									}
								}
							}

							text = text.slice(0, -2)

							if (text.length > 105)
								this.names = text.slice(0,105) + '...'
							else
								this.names = text
						}

						this.items = arr
					}
					else {
						this.items = []
					}
				})
				.catch(err => console.log(err))
			}
		},
		mounted () {
			/*fetch(DB + WARRANT_INFO + '?id=' + this.$route.params.id, {
				credentials: 'include'
			})
			.then(res => res.json())
			.then(res => {
				return res[0].f_92
			})
			.then(ids => {
				if (ids) {
					ids = ids.slice(1,-1).split(',')
					this.fill(ids)
				}
				else {
					this.fill()
				}
			})*/
			if (this.npa)
				this.fill(this.npa)
			else
				this.fill()

            //this.fill()
		}
	}

</script>

<style>
.npa_violations {
	position: absolute;
    left: 0;
    top: 0;
    right: 0;
    padding: 0 !important;
    bottom: 0;
	border: none !important;
}

.npa_violations > button {
	height: 100%;
	width: 100%;
	background: #fff;
	border: none;
}

.npa-violation-table {
	font-size: 13px;
}

.npa_violations > button:hover {
	background: #eef;
}

button.dropdown-toggle:disabled,
button.dropdown-toggle:disabled:hover {
    background: #eee;
}

.npa-violation-dropdown-group {
	width: 100%;
	padding: 0 !important;
	border: none !important;
	margin: 0;
	position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
}

.npa-violation-dropdown-group > button.dropdown-toggle {
	width: 100%;
	font-weight: normal;
	height: 100%;
	/*font-size: 12px;*/
}

.npa-violation-dropdown-group > ul.dropdown-menu {
	min-width: 860px !important;
	/*top: auto !important;
	bottom: 100% !important;*/
	margin-bottom: 2px !important;
	max-height: 500px;
	overflow-x: auto;
}

/*.npa-violation-dropdown-group > button > span.caret {
	float: right;
}
*/
.npa-violation-table {
	width: 100%;
	height:100%;
}

.npa-violation-table tr {
	height: 30px;
}

.npa-violation-table td.npa-violation-td-checkbox {
	width: 30px;
	min-width: 30px;
}

.npa-violation-checkbox {
	margin-top: 0px !important;
	margin-bottom: 18px !important;
	margin-left: 7px !important;
}

/*ul.dropdown-menu {
	padding-left: 10px;
	padding-right: 10px;
	max-height: 500px;
	min-width: 200px;
	overflow-y: auto;
}*/
</style>


// WEBPACK FOOTER //
// npaViolations.vue?34429aa4